// Components
import { DatePicker, FormElems, Overlay } from '../../components/';
import { validators } from '../../utils/validators';

// Actions
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import { downloadBulkRefundPreFilledFileRequest } from './redux/bulkRefund.actions';

// Constants
import { PAYMENT_MODE } from './constant';
import { toast } from 'react-toastify';

// Libraries
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const setMerchantFilter = underlyingMerchant => {
    const merchantOptions = [];
    if (underlyingMerchant.length) {
        underlyingMerchant.forEach(merchant => {
            merchantOptions.push({
                name:
                    merchant.name.length > 30
                        ? `${merchant.name.substring(0, 30)}...`
                        : merchant.name,
                value: merchant.entityCode,
            });
        });
        return merchantOptions;
    }

    return merchantOptions;
};

const renderDateInput = field => <DatePicker {...field} />;

const validate = values => {
    const { REQUIRED } = validators;

    if (REQUIRED(values.merchantId)) {
        toast.error('Please Select a merchant');
        return false;
    }

    if (REQUIRED(values.minAmt)) {
        toast.error('Please Enter a minimum amount');
        return false;
    }

    if (REQUIRED(values.maxAmt)) {
        toast.error('Please Enter a maximum amount');
        return false;
    }

    if (parseInt(values.maxAmt, 10) <= parseInt(values.minAmt, 10)) {
        toast.error('Please Enter valid amount range');
        return false;
    }

    return true;
};

const DownloadPreFilledFileFilter = ({
    showOverlay,
    closeFilter,
    handleSubmit,
    userLevel,
    staticData,
    actions,
    auth,
}) => {
    const startDateDefault =
        moment()
            .endOf('day')
            .subtract(1, 'days') || null;
    const endDateDefault = moment().endOf('day') || null;

    const [startDate, setStartDate] = useState(startDateDefault);
    const [endDate, setEndDate] = useState(endDateDefault);
    const [focusedInput, setFocusedInput] = useState(null);
    const { underlyingMerchant } = staticData;

    const merchantList = setMerchantFilter(underlyingMerchant);

    const handleFormSubmit = values => {
        if (auth.userDetails.userLevel === 'MERCHANT') {
            values.merchantId = auth.userDetails.associatedEntityId;
        }
        if (validate(values)) {
            actions.downloadBulkRefundPreFilledFileRequest(values);
        }
    };

    return (
        <>
            <div className="preFilledFileFilterWrap">
                <>
                    {showOverlay ? (
                        <Overlay closeFilter={closeFilter} isTransparent />
                    ) : null}
                    <div className="preFilledFileFilter">
                        <div className="tableFilter-bulkUpload">
                            <form
                                className="filter-form"
                                onSubmit={handleSubmit(handleFormSubmit)}
                            >
                                <div className="form-field">
                                    <p className="label filterTitle">
                                        Date Range
                                    </p>
                                    <Field
                                        name="createdOn"
                                        startDateId="StartDate"
                                        endDateId="EndDate"
                                        startDate={startDate}
                                        endDate={endDate}
                                        focusedInput={focusedInput}
                                        onSetStartDate={startDate => {
                                            setStartDate(startDate);
                                        }}
                                        onSetEndDate={endDate => {
                                            setEndDate(endDate);
                                        }}
                                        onFocusedInput={focusedInput => {
                                            setFocusedInput(focusedInput);
                                        }}
                                        maximumNights={5}
                                        component={renderDateInput}
                                    />
                                </div>

                                <div className="form-field">
                                    <p className="label filterTitle">
                                        Amount Range
                                    </p>
                                    <div className="parallelInp">
                                        <div className="field1">
                                            <Field
                                                name="minAmt"
                                                placeholder="Min. Amount"
                                                type="number"
                                                component={FormElems.Input}
                                            />
                                        </div>

                                        <div className="field2">
                                            <Field
                                                name="maxAmt"
                                                placeholder="Max. Amount"
                                                type="number"
                                                component={FormElems.Input}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-field">
                                    <p className="label filterTitle">
                                        Payment Mode
                                    </p>
                                    <Field
                                        name="paymentMode"
                                        data={PAYMENT_MODE}
                                        label="Select Payment Mode"
                                        labelField="name"
                                        valueField="value"
                                        component={FormElems.Select}
                                    />
                                </div>

                                {userLevel !== 'MERCHANT' ? (
                                    <div className="form-field">
                                        <p className="label filterTitle">
                                            Merchant Name
                                        </p>
                                        <Field
                                            name="merchantId"
                                            data={merchantList}
                                            label="Select Merchant"
                                            labelField="name"
                                            valueField="value"
                                            component={FormElems.Select}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}

                                <div className="form-field actions">
                                    <FormElems.Button
                                        buttonType="primary"
                                        text="DOWNLOAD"
                                        id="submit-button"
                                        handleClick={handleSubmit(
                                            handleFormSubmit
                                        )}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

DownloadPreFilledFileFilter.propTypes = {
    showOverlay: PropTypes.bool,
    closeFilter: PropTypes.func,
    handleSubmit: PropTypes.func,
    userLevel: PropTypes.string,
    staticData: PropTypes.object,
    actions: PropTypes.object,
    auth: PropTypes.object,
};

const mapStateToProps = ({ auth, form, staticData }) => ({
    auth,
    formData: form['pre-filled-filter'],
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            downloadBulkRefundPreFilledFileRequest,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'pre-filled-filter',
        enableReinitialize: true,
        initialValues: {
            createdOn: {
                startDate:
                    moment()
                        .endOf('day')
                        .subtract(1, 'days')
                        .format() || null,
                endDate:
                    moment()
                        .endOf('day')
                        .format() || null,
            },
        },
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(DownloadPreFilledFileFilter);
